/**
 * Our popup-state
 */
import React from 'react';
import PropTypes from 'prop-types';

// Context
const State = React.createContext();
const Dispatch = React.createContext();

// Reducer
const reducer = (state, action) => action;


const Provider = ({children}) => {
    const [state, dispatch] = React.useReducer(reducer, null);

    return (<State.Provider value={state}>
        <Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
    </State.Provider>);
};

Provider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.elementType,
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.arrayOf(PropTypes.elementType),
    ]),
};

// Export
export const ActivePopup = {
    State,
    Dispatch,
    Provider,
};
